import { sharingDocumentModel } from './sharing-document-model';
import { StoreContractorModelType } from './types';

export const storeContractorModel: StoreContractorModelType = {
    sharingDocument: sharingDocumentModel,
};
